
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.32 32.82A13.12 13.12 0 1126.63 20M31.66 1.64a3.66 3.66 0 00-4 3.72c0 2.47.83 2.06.83 7.83s-3.72 6.19-3.72 14 3.55 10.72 3.55 10.72a8.27 8.27 0 003.3.42 8.33 8.33 0 003.3-.42s3.54-2.88 3.54-10.72-3.71-8.25-3.71-14 .82-5.36.82-7.83a3.66 3.66 0 00-3.91-3.72zM34.54 13.64h-5.77","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"16","cy":"25.28","r":"1.53","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"12.86","cy":"20.33","r":"1.53","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"19.13","cy":"20.33","r":"1.53","fill":"#241f21"}})])
          )
        }
      }
    